module.exports = __webpack_public_path__ + "static/vote_yay_square.3926a030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/vote_yay_square.jpg
// module id = 384
// module chunks = 35783957827783